var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { pickFirstCzechLanguage } from "./pickFirstCzechLanguage";
var getFirstOrUndefined = function (items) {
    return items && items.length ? items[0] : undefined;
};
export var isOnixItemEmpty = function (item) {
    return !item || (!item.id && !item.value);
};
var defined = function (items) {
    return (items !== null && items !== void 0 ? items : []).filter(function (item) { return item != null; });
};
var ensureAtLeastOne = function (items, factory) {
    var filtered = defined(items);
    return filtered.length ? filtered : [factory()];
};
export function normalizeTitleFormValues(_a) {
    var initialValues = _a.initialValues, nameTypeTbl = _a.nameTypeTbl, langRoleTbl = _a.langRoleTbl, languageTbl = _a.languageTbl, textContentTypeTbl = _a.textContentTypeTbl, resourceTypeTbl = _a.resourceTypeTbl, resourceModeTbl = _a.resourceModeTbl, audienceTypeTbl = _a.audienceTypeTbl, subjectSchemeTbl = _a.subjectSchemeTbl, roleOnixTable = _a.roleOnixTable;
    var normalizedInitialValues = (initialValues !== null && initialValues !== void 0 ? initialValues : {});
    var _b = (nameTypeTbl !== null && nameTypeTbl !== void 0 ? nameTypeTbl : {}).onixCodetableItems, nameTypeItems = _b === void 0 ? [] : _b;
    var _c = (langRoleTbl !== null && langRoleTbl !== void 0 ? langRoleTbl : {}).onixCodetableItems, languageRoleItems = _c === void 0 ? [] : _c;
    var _d = (languageTbl !== null && languageTbl !== void 0 ? languageTbl : {}).onixCodetableItems, languageItems = _d === void 0 ? [] : _d;
    var _e = (textContentTypeTbl !== null && textContentTypeTbl !== void 0 ? textContentTypeTbl : {}).onixCodetableItems, textContentTypeItems = _e === void 0 ? [] : _e;
    var _f = (resourceTypeTbl !== null && resourceTypeTbl !== void 0 ? resourceTypeTbl : {}).onixCodetableItems, resourceTypeItems = _f === void 0 ? [] : _f;
    var _g = (resourceModeTbl !== null && resourceModeTbl !== void 0 ? resourceModeTbl : {}).onixCodetableItems, resourceModeItems = _g === void 0 ? [] : _g;
    var _h = (audienceTypeTbl !== null && audienceTypeTbl !== void 0 ? audienceTypeTbl : {}).onixCodetableItems, audienceTypeItems = _h === void 0 ? [] : _h;
    var _j = (subjectSchemeTbl !== null && subjectSchemeTbl !== void 0 ? subjectSchemeTbl : {}).onixCodetableItems, subjectSchemeItems = _j === void 0 ? [] : _j;
    var _k = (roleOnixTable !== null && roleOnixTable !== void 0 ? roleOnixTable : {}).onixCodetableItems, publisherRoleItems = _k === void 0 ? [] : _k;
    var names = ensureAtLeastOne(normalizedInitialValues.names, function () { return ({
        type: {},
        name: "",
    }); }).map(function (nameEntry) { return (__assign(__assign({}, nameEntry), { type: isOnixItemEmpty(nameEntry.type)
            ? getFirstOrUndefined(nameTypeItems)
            : nameEntry.type })); });
    var languages = ensureAtLeastOne(normalizedInitialValues.languages, function () { return ({
        role: {},
        language: {},
    }); }).map(function (languageEntry) { return (__assign(__assign({}, languageEntry), { role: isOnixItemEmpty(languageEntry.role)
            ? getFirstOrUndefined(languageRoleItems)
            : languageEntry.role, language: isOnixItemEmpty(languageEntry.language)
            ? pickFirstCzechLanguage(languageItems)
            : languageEntry.language })); });
    var subjects = defined(normalizedInitialValues.subjects).map(function (subjectEntry) {
        var _a;
        var selectedScheme = isOnixItemEmpty(subjectEntry === null || subjectEntry === void 0 ? void 0 : subjectEntry.scheme)
            ? getFirstOrUndefined(subjectSchemeItems)
            : subjectEntry.scheme;
        return __assign(__assign({}, subjectEntry), { scheme: selectedScheme, code: (subjectEntry === null || subjectEntry === void 0 ? void 0 : subjectEntry.code) && String(subjectEntry.code).trim() !== ""
                ? subjectEntry.code
                : ((_a = selectedScheme === null || selectedScheme === void 0 ? void 0 : selectedScheme.value) !== null && _a !== void 0 ? _a : "") });
    });
    var textContents = defined(normalizedInitialValues.textContents).map(function (textContentEntry) { return (__assign(__assign({}, textContentEntry), { type: isOnixItemEmpty(textContentEntry.type)
            ? getFirstOrUndefined(textContentTypeItems)
            : textContentEntry.type, language: isOnixItemEmpty(textContentEntry.language)
            ? pickFirstCzechLanguage(languageItems)
            : textContentEntry.language })); });
    var supportingResources = defined(normalizedInitialValues.supportingResources).map(function (resourceEntry) { return (__assign(__assign({}, resourceEntry), { type: isOnixItemEmpty(resourceEntry.type)
            ? getFirstOrUndefined(resourceTypeItems)
            : resourceEntry.type, mode: isOnixItemEmpty(resourceEntry.mode)
            ? getFirstOrUndefined(resourceModeItems)
            : resourceEntry.mode })); });
    var audiences = defined(normalizedInitialValues.audiences).map(function (audienceEntry) { return (__assign(__assign({}, audienceEntry), { type: isOnixItemEmpty(audienceEntry.type)
            ? getFirstOrUndefined(audienceTypeItems)
            : audienceEntry.type })); });
    var publicationPlaces = ensureAtLeastOne(normalizedInitialValues.publicationPlaces, function () { return ({ city: "" }); });
    var titlePublishers = ensureAtLeastOne(normalizedInitialValues.titlePublishers, function () { return ({ publisher: {}, role: {} }); }).map(function (titlePublisherEntry) { return (__assign(__assign({}, titlePublisherEntry), { role: isOnixItemEmpty(titlePublisherEntry.role)
            ? getFirstOrUndefined(publisherRoleItems)
            : titlePublisherEntry.role })); });
    return __assign(__assign({}, normalizedInitialValues), { names: names, languages: languages, subjects: subjects, textContents: textContents, supportingResources: supportingResources, audiences: audiences, publicationPlaces: publicationPlaces, titlePublishers: titlePublishers });
}
export var useTitleFormValues = function (_a) {
    var initialValues = _a.initialValues, nameTypeTbl = _a.nameTypeTbl, langRoleTbl = _a.langRoleTbl, languageTbl = _a.languageTbl, textContentTypeTbl = _a.textContentTypeTbl, resourceTypeTbl = _a.resourceTypeTbl, resourceModeTbl = _a.resourceModeTbl, audienceTypeTbl = _a.audienceTypeTbl, subjectSchemeTbl = _a.subjectSchemeTbl, roleOnixTable = _a.roleOnixTable;
    return React.useMemo(function () {
        return normalizeTitleFormValues({
            initialValues: initialValues,
            nameTypeTbl: nameTypeTbl,
            langRoleTbl: langRoleTbl,
            languageTbl: languageTbl,
            textContentTypeTbl: textContentTypeTbl,
            resourceTypeTbl: resourceTypeTbl,
            resourceModeTbl: resourceModeTbl,
            audienceTypeTbl: audienceTypeTbl,
            subjectSchemeTbl: subjectSchemeTbl,
            roleOnixTable: roleOnixTable,
        });
    }, [
        initialValues,
        nameTypeTbl,
        langRoleTbl,
        languageTbl,
        textContentTypeTbl,
        resourceTypeTbl,
        resourceModeTbl,
        audienceTypeTbl,
        subjectSchemeTbl,
        roleOnixTable,
    ]);
};
